module.exports = __webpack_public_path__ + "img/game_main_pc_234_off.fd40e47e.png";